export default "__VITE_ASSET__DkuBU7kN__"